export default "__VITE_ASSET__6fcea833__"